export enum setupTypes {
  DOCUMENT_BRIDGE_DATA_LISTENERS_ADDED = 'DOCUMENT_BRIDGE_DATA_LISTENERS_ADDED',
  SET_ACTIVE_BRIDGE = 'SET_ACTIVE_BRIDGE',
  SET_BRIDGE_NAME = 'SET_BRIDGE_NAME',
  SET_GIG_OPTIONS = 'SET_GIG_OPTIONS',
  SET_PRESENTER_TRACKS = 'SET_PRESENTER_TRACKS',
  SET_ROOM = 'SET_ROOM',
  SET_ROOM_ERROR = 'SET_ROOM_ERROR',
  SET_SERVICED_OPTION = 'SET_SERVICED_OPTION',
  SET_DEBUG = 'SET_DEBUG',
  SEND_DEBUG_STATS = 'SEND_DEBUG_STATS',
  SET_AVAILABLE_FEATURES = 'SET_AVAILABLE_FEATURES'
}
